var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// /Users/martinrajdl/www/nejlepsi.cx/~/enquire.js/src/index.js
// module id = 3
// module chunks = 0